<template>
  <div class="comment-list" v-loading="commentLoading">
    <div v-if="commentList.length === 0 && !commentLoading" class="no-comment">
      暂无评论，快来抢沙发吧~
    </div>

    <div
      v-for="item in commentList"
      :key="item.id"
      class="comment-item"
      :class="{ 'sub-comment': item.topReplyCommentId && item.topReplyCommentId > 0 }"
    >
      <!-- 评论主体 -->
      <div class="comment-main">
        <head-image
          :url="item.userAvatar"
          :name="item.userNickname || '?'"
          :size="32"
          :id="item.userId"
          radius="50%"
        ></head-image>
        <div class="comment-body">
          <div class="comment-header">
            <span class="comment-nickname">{{ item.userNickname }}</span>
            <span v-if="isVideoAuthor(item.userId)" class="comment-author">作者</span>
            <span class="comment-time">{{ formatTime(item.createTime) }}</span>
            <span v-if="item.ipAddress" class="comment-ip">· {{ item.ipAddress }}</span>
            <span v-if="item.isOwner" class="comment-delete" @click="handleDelete(item)">删除</span>
          </div>
          <!-- 回复目标 -->
          <div v-if="item.replyToUserId" class="comment-reply-to">
            回复 <span class="reply-nickname">@{{ item.replyToUserNickname }}</span>
          </div>
          <div class="comment-content" v-if="item.type === $enums.MESSAGE_TYPE.TEXT" v-html="$emo.transform(item.content)"></div>
          <div class="comment-content" v-else-if="item.type === $enums.MESSAGE_TYPE.IMAGE">
            <img :src="JSON.parse(item.content).originUrl" class="comment-image" @click="previewImage(JSON.parse(item.content).originUrl)" />
          </div>
          <div class="comment-content comment-word-voice" v-else-if="item.type === $enums.MESSAGE_TYPE.WORD_VOICE">
            <span class="word" :title="JSON.parse(item.content).word" @click.stop="playVoice(JSON.parse(item.content))">{{JSON.parse(item.content).word}}</span>
            <span class="icon iconfont icon-xitongxiaoxi" @click.stop="playVoice(JSON.parse(item.content))"></span>
          </div>
          <div class="comment-actions">
            <span class="action-like" :class="{ liked: $store.getters.isCommentLiked(item.id) }" @click="handleCommentLike(item)">
              <i :class="['iconfont', $store.getters.isCommentLiked(item.id) ? 'icon-aixin' : 'icon-hongxin1']"></i>
              <span v-if="item.likeCount > 0">{{ item.likeCount }}</span>
            </span>
            <span class="action-reply" @click="toggleReply(item)">回复</span>
          </div>

          <!-- 子评论数入口 -->
          <div
            v-if="item.topReplyCommentId === '0' && item.childCommentCount > 0"
            class="child-comment-entry"
            @click="toggleChildComments(item)"
          >
            <span v-if="!item._showChildren">展开 {{ item.childCommentCount }} 条回复</span>
            <span v-else>收起回复</span>
          </div>

          <!-- 子评论列表 -->
          <div v-if="item._showChildren" class="child-comments">
            <div v-if="item._childLoading" class="child-loading">
              <i class="el-icon-loading"></i> 加载中...
            </div>
            <div
              v-for="child in (item._children || [])"
              :key="child.id"
              class="comment-item sub-comment"
            >
              <div class="comment-main">
                <head-image
                  :url="child.userAvatar"
                  :name="child.userNickname || '?'"
                  :id="child.userId"
                  :size="28"
                  radius="50%"
                ></head-image>
                <div class="comment-body">
                  <div class="comment-header">
                    <span class="comment-nickname">{{ child.userNickname }}</span>
                    <span v-if="isVideoAuthor(child.userId)" class="comment-author">作者</span>
                    <span class="comment-time">{{ formatTime(child.createTime) }}</span>
                    <span v-if="child.ipAddress" class="comment-ip">· {{ child.ipAddress }}</span>
                    <span v-if="child.isOwner" class="comment-delete" @click="handleDelete(child)">删除</span>
                  </div>
                  <div v-if="child.replyToUserId" class="comment-reply-to">
                    回复 <span class="reply-nickname">@{{ child.replyToUserNickname }}</span>
                  </div>
                  <div class="comment-content" v-if="child.type === $enums.MESSAGE_TYPE.TEXT" v-html="$emo.transform(child.content)"></div>
                  <div class="comment-content" v-else-if="child.type === $enums.MESSAGE_TYPE.IMAGE">
                    <img :src="JSON.parse(child.content).originUrl" class="comment-image" @click="previewImage(JSON.parse(child.content).originUrl)" />
                  </div>
                  <div class="comment-content comment-word-voice" v-else-if="child.type === $enums.MESSAGE_TYPE.WORD_VOICE">
                    <span class="word" :title="JSON.parse(child.content).word" @click.stop="playVoice(JSON.parse(child.content))">{{JSON.parse(child.content).word}}</span>
                    <span class="icon iconfont icon-xitongxiaoxi" @click.stop="playVoice(JSON.parse(child.content))"></span>
                  </div>
                  <div class="comment-actions">
                    <span class="action-like" :class="{ liked: $store.getters.isCommentLiked(child.id) }" @click="handleCommentLike(child)">
                      <i :class="['iconfont', $store.getters.isCommentLiked(child.id) ? 'icon-aixin' : 'icon-hongxin1']"></i>
                      <span v-if="child.likeCount > 0">{{ child.likeCount }}</span>
                    </span>
                    <span class="action-reply" @click="toggleReply(child)">回复</span>
                  </div>
                </div>
              </div>

              <!-- 子评论的回复输入框 -->
              <div v-if="child._showReply" class="reply-input-wrapper">
                <input-box :ref="'replyInput_' + child.id" width="100%" :placeholder="'回复 ' + child.userNickname" :character-id="commentForm.characterId"
                           @send="(sendObj) => handleSendReply(child, sendObj)"
                           @sendWord="(sendObj) => handleSendWordReply(child, sendObj)"></input-box>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 顶级评论的回复输入框 -->
      <div v-if="item._showReply && item.topReplyCommentId === '0'" class="reply-input-wrapper">
        <input-box :ref="'replyInput_' + item.id" width="100%" :placeholder="'回复 ' + item.userNickname" :character-id="commentForm.characterId"
                   @send="(sendObj) => handleSendReply(item, sendObj)"
                   @sendWord="(sendObj) => handleSendWordReply(item, sendObj)"></input-box>
      </div>
    </div>

    <!-- 加载更多 -->
    <div v-if="commentHasMore" class="load-more" @click="loadMoreComments">
      <span v-if="!commentLoadingMore">加载更多</span>
      <span v-else><i class="el-icon-loading"></i> 加载中...</span>
    </div>
  </div>
</template>

<script>
import HeadImage from '@/components/common/HeadImage.vue'
import InputBox from '@/components/common/InputBox.vue'

export default {
  name: 'ShortVideoCommentList',
  components: {
    HeadImage,
    InputBox
  },
  props: {
    video: {
      type: Object,
      default: () => ({})
    },
    commentForm: {
      type: Object,
      default: () => ({
        characterAvatarId: null,
        characterId: null,
        nickName: '',
        avatar: ''
      })
    }
  },
  data() {
    return {
      commentList: [],
      commentPageNo: 1,
      commentPageSize: 50,
      commentTotal: 0,
      commentLoading: false,
      commentLoadingMore: false,
      commentHasMore: true,
      audio: null,
      audioSrc: ''
    }
  },
  mounted() {
    if (this.video && this.video.id) {
      this.fetchComments()
    }
  },
  watch: {
    'video.id'() {
      this.resetAndFetch()
    }
  },
  methods: {
    resetAndFetch() {
      this.commentList = []
      this.commentPageNo = 1
      this.commentTotal = 0
      this.commentHasMore = true
      if (this.video && this.video.id) {
        this.fetchComments()
      }
    },

    // 供父组件调用的刷新方法
    refresh() {
      this.resetAndFetch()
    },

    // 关闭所有回复输入框
    closeAllReplies() {
      this.commentList.forEach(c => {
        if (c._showReply) this.$set(c, '_showReply', false)
        if (c._children) {
          c._children.forEach(child => {
            if (child._showReply) this.$set(child, '_showReply', false)
          })
        }
      })
    },

    formatTime(dateStr) {
      if (!dateStr) return ''
      const now = new Date()
      const d = new Date(dateStr)
      const diff = now - d
      if (diff < 60000) return '刚刚'
      if (diff < 3600000) return Math.floor(diff / 60000) + '分钟前'
      if (diff < 86400000) return Math.floor(diff / 3600000) + '小时前'
      if (diff < 172800000) return '昨天'
      if (diff < 2592000000) return Math.floor(diff / 86400000) + '天前'
      return this.formatDate(dateStr)
    },

    formatDate(dateStr) {
      if (!dateStr) return ''
      const d = new Date(dateStr)
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const h = String(d.getHours()).padStart(2, '0')
      const min = String(d.getMinutes()).padStart(2, '0')
      return `${y}-${m}-${day} ${h}:${min}`
    },

    // 判断评论用户是否为视频作者，统一转换为字符串以兼容接口返回的数字/字符串 ID
    isVideoAuthor(userId) {
      return this.video && this.video.userId != null && userId != null && String(this.video.userId) === String(userId)
    },

    fetchComments() {
      if (this.commentLoading || this.commentLoadingMore) return
      this.commentLoading = true

      this.$http({
        url: '/shortVideoComment/pageList',
        method: 'post',
        params: {
          currentPage: 1,
          pageSize: this.commentPageSize
        },
        data: {
          videoId: this.video.id
        }
      }).then((res) => {
        const list = res.data || []
        this.commentList = list.map(item => ({ ...item, _showChildren: false, _children: [], _showReply: false, _childLoading: false }))
        this.commentTotal = res.total || 0
        this.commentPageNo = 1
        this.commentHasMore = this.commentList.length < this.commentTotal
      }).finally(() => {
        this.commentLoading = false
      })
    },

    loadMoreComments() {
      if (this.commentLoadingMore || !this.commentHasMore) return
      this.commentLoadingMore = true

      const nextPage = this.commentPageNo + 1
      this.$http({
        url: '/shortVideoComment/pageList',
        method: 'post',
        params: {
          currentPage: nextPage,
          pageSize: this.commentPageSize
        },
        data: {
          videoId: this.video.id
        }
      }).then((res) => {
        const list = res.data || []
        const newItems = list.map(item => ({ ...item, _showChildren: false, _children: [], _showReply: false, _childLoading: false }))
        this.commentList.push(...newItems)
        this.commentPageNo = nextPage
        this.commentTotal = res.total || 0
        this.commentHasMore = this.commentList.length < this.commentTotal
      }).finally(() => {
        this.commentLoadingMore = false
      })
    },

    // 发送回复
    handleSendReply(parentComment, sendObj) {
      let content = null;
      if (sendObj.type === this.$enums.MESSAGE_TYPE.IMAGE) {
        content = JSON.stringify(sendObj.content)
      } else {
        content = sendObj.content
      }
      this.$http({
        url: '/shortVideoComment/add',
        method: 'post',
        data: {
          videoId: this.video.id,
          content: content,
          type: sendObj.type,
          replyCommentId: parentComment.id,
          characterId: this.commentForm.characterId,
          avatarId: this.commentForm.characterAvatarId
        }
      }).then((res) => {
        this.$message.success('回复成功')
        if (parentComment.topReplyCommentId === '0') {
          parentComment._children.push({ ...res, isOwner: true })
          parentComment.childCommentCount = (parentComment.childCommentCount || 0) + 1
          parentComment._showChildren = true;
        } else {
          const topComment = this.commentList.find(c => c.id === parentComment.topReplyCommentId)
          if (topComment) {
            topComment._children.push({ ...res, isOwner: true })
            topComment.childCommentCount = (parentComment.childCommentCount || 0) + 1
            topComment._showChildren = true;
          }
        }

        parentComment._showReply = false
      })
    },

    handleSendWordReply(parentComment, data) {
      if (!data) {
        return
      }
      let content = JSON.stringify({
        id: data.id,
        templateGroupId: data.templateGroupId,
        characterId: data.characterId,
        characterName: data.characterName,
        word: data.word,
        voice: data.voice
      })
      this.$http({
        url: '/shortVideoComment/add',
        method: 'post',
        data: {
          videoId: this.video.id,
          content: content,
          type: this.$enums.MESSAGE_TYPE.WORD_VOICE,
          replyCommentId: parentComment.id,
          characterId: this.commentForm.characterId,
          avatarId: this.commentForm.characterAvatarId
        }
      }).then((res) => {
        this.$message.success('回复成功')
        if (parentComment.topReplyCommentId === '0') {
          parentComment._children.push({ ...res, isOwner: true })
          parentComment.childCommentCount = (parentComment.childCommentCount || 0) + 1
          parentComment._showChildren = true;
        } else {
          const topComment = this.commentList.find(c => c.id === parentComment.topReplyCommentId)
          if (topComment) {
            topComment._children.push({ ...res, isOwner: true })
            topComment.childCommentCount = (parentComment.childCommentCount || 0) + 1
            topComment._showChildren = true;
          }
        }

        parentComment._showReply = false
      })
    },

    // 删除评论
    handleDelete(comment) {
      this.$confirm('确定删除该评论吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: '/shortVideoComment/delete',
          method: 'delete',
          data: { id: comment.id }
        }).then(() => {
          this.$message.success('删除成功')
          if (comment.topReplyCommentId && comment.topReplyCommentId > 0) {
            const parentComment = this.commentList.find(c => c.id === comment.topReplyCommentId)
            if (parentComment && parentComment._children) {
              const idx = parentComment._children.findIndex(c => c.id === comment.id)
              if (idx >= 0) {
                parentComment._children.splice(idx, 1)
                parentComment.childCommentCount = Math.max(0, (parentComment.childCommentCount || 0) - 1)
              }
            }
          } else {
            const idx = this.commentList.findIndex(c => c.id === comment.id)
            if (idx >= 0) {
              this.commentList.splice(idx, 1)
              this.commentTotal = Math.max(0, this.commentTotal - 1)
            }
          }
        })
      }).catch(() => {})
    },

    // 切换回复输入框
    toggleReply(comment) {
      const willShow = !comment._showReply
      console.log('willShow', willShow)
      // 关闭其他打开的回复输入框和顶部评论输入框
      this.$emit('closeCommentInput')
      this.commentList.forEach(c => {
        if (c !== comment && c._showReply) {
          this.$set(c, '_showReply', false)
        }
        if (c._children) {
          c._children.forEach(child => {
            if (child !== comment && child._showReply) {
              this.$set(child, '_showReply', false)
            }
          })
        }
      })
      this.$set(comment, '_showReply', willShow)
      if (willShow) {
        const refKey = 'replyInput_' + comment.id
        this.$nextTick(() => {
          console.log('refKey', refKey)
          const inst = this.$refs[refKey]
          console.log('inst', inst)
          if (inst) {
            const target = Array.isArray(inst) ? inst[0] : inst
            if (target && target.view) target.view()
          }
        })
      }
    },

    // 展开/收起子评论
    toggleChildComments(comment) {
      if (comment._showChildren) {
        this.$set(comment, '_showChildren', false)
        return
      }
      this.$set(comment, '_showChildren', true)
      if (comment._children && comment._children.length > 0) return

      this.$set(comment, '_childLoading', true)
      this.$http({
        url: '/shortVideoComment/pageList',
        method: 'post',
        params: {
          currentPage: 1,
          pageSize: 50
        },
        data: {
          videoId: this.video.id,
          topReplyCommentId: comment.id
        }
      }).then((res) => {
        const list = res.data || []
        this.$set(comment, '_children', list.map(item => ({ ...item, _showReply: false })))
      }).finally(() => {
        this.$set(comment, '_childLoading', false)
      })
    },

    // 评论点赞
    handleCommentLike(comment) {
      if (this.$store.getters.isCommentLiked(comment.id)) {
        return
      }
      this.$http({
        url: `/shortVideoComment/addCommentLike/${comment.id}`,
        method: 'post'
      }).then(() => {
        this.$store.commit('markCommentLiked', comment.id)
        comment.likeCount = (comment.likeCount || 0) + 1
      })
    },

    // 预览图片
    previewImage(url) {
      this.$store.commit('showFullImageBox', url)
    },

    playVoice(word) {
      // 如果当前有正在播放的 audio，先清理
      if (this.audio) {
        this.audio.pause();
        this.audio = null;
        this.audioSrc = '';
      }

      this.audio = new Audio();
      this.audioSrc = word.voice;
      this.audio.src = word.voice;

      // 监听播放完成事件
      const handleEnded = () => {
        if (this.audio) {
          this.audio.pause();
          this.audio = null;
          this.audioSrc = '';
        }
        // 移除事件监听器
        if (this.audio) {
          this.audio.removeEventListener('ended', handleEnded);
        }
      };

      // 添加 ended 事件监听
      this.audio.addEventListener('ended', handleEnded);

      // 开始播放
      this.audio.play().catch(err => {
        console.error('音频播放失败:', err);
        // 播放失败时清理
        if (this.audio) {
          this.audio = null;
          this.audioSrc = '';
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">
.comment-list {
  flex: 1;
  overflow-y: auto;
  padding: 0 12px;
}

.no-comment {
  text-align: center;
  color: #ccc;
  font-size: 13px;
  padding: 40px 0;
}

.comment-item {
  padding: 12px 0;
  border-bottom: 1px solid #f5f5f5;

  &.sub-comment {
    padding-left: 12px;
    background: #fafafa;
    border-radius: 4px;
    margin-top: 4px;
  }
}

.comment-main {
  display: flex;
  gap: 10px;
}

.comment-body {
  flex: 1;
  min-width: 0;
}

.comment-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;

  .comment-nickname {
    font-size: 13px;
    color: #999;
  }

  .comment-author {
    font-size: 12px;
    padding: 2px 6px;
    border-radius: 3px;
    background: #f56c6c;
    color: #fff;
  }

  .comment-time {
    font-size: 11px;
    color: #ccc;
  }

  .comment-ip {
    font-size: 11px;
    color: #ccc;
  }

  .comment-delete {
    font-size: 12px;
    color: #f56c6c;
    cursor: pointer;
    margin-left: auto;

    &:hover {
      text-decoration: underline;
    }
  }
}

.comment-reply-to {
  font-size: 12px;
  color: #999;
  margin-bottom: 4px;

  .reply-nickname {
    color: #409eff;
  }
}

.comment-content {
  font-size: 14px;
  color: #333;
  line-height: 1.6;
  word-break: break-all;

  ::v-deep img {
    height: 22px;
    width: 22px;
    vertical-align: middle;
    margin: 0 2px;
  }

  &.comment-word-voice {
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    user-select: none;

    .word {
      cursor: pointer;
      color: #409eff;
      font-weight: 500;
      border-bottom: 1px dashed #409eff;
      padding-bottom: 1px;
      transition: color 0.2s;

      &:hover {
        color: #66b1ff;
      }
    }

    .icon-xitongxiaoxi {
      cursor: pointer;
      color: #e6a23c;
      font-size: 16px;
      transition: color 0.2s;

      &:hover {
        color: #f3d19e;
      }
    }
  }

  .comment-image {
    min-width: 90px;
    min-height: 90px;
    max-width: 180px;
    max-height: 180px;
    border-radius: 4px;
    cursor: pointer;
  }
}

.comment-actions {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 6px;

  .action-like {
    font-size: 12px;
    color: #999;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;
    user-select: none;

    i {
      font-size: 13px;
    }

    &.liked {
      color: #f56c6c;
      cursor: default;

      i {
        color: #f56c6c;
      }
    }
  }

  .action-reply {
    font-size: 12px;
    color: #999;
    cursor: pointer;

    &:hover {
      color: #409eff;
    }
  }
}

.child-comment-entry {
  font-size: 12px;
  color: #409eff;
  cursor: pointer;
  margin-top: 6px;
  display: inline-block;

  &:hover {
    text-decoration: underline;
  }
}

.child-comments {
  margin-top: 8px;
  padding-left: 8px;
  border-left: 2px solid #f0f0f0;

  .child-loading {
    font-size: 12px;
    color: #999;
    padding: 8px 0;
  }
}

.reply-input-wrapper {
  margin-top: 8px;
  margin-left: 42px;
}

.load-more {
  text-align: center;
  padding: 12px 0;
  font-size: 13px;
  color: #409eff;
  cursor: pointer;
  user-select: none;

  &:hover {
    text-decoration: underline;
  }
}
</style>
